import { useEffect, useRef } from "react";

let adSenseLoaded = false;

function loadAdSense() {
  const client = process.env.REACT_APP_ADSENSE_CLIENT;
  if (!client || adSenseLoaded || typeof document === "undefined") return;
  adSenseLoaded = true;
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${client}`;
  script.crossOrigin = "anonymous";
  document.head.appendChild(script);
}

export default function AdBanner({ slot, format = "auto", className = "" }) {
  const insRef = useRef(null);
  const client = process.env.REACT_APP_ADSENSE_CLIENT;

  useEffect(() => {
    if (!client || !slot) return;
    loadAdSense();
    try {
      if (insRef.current) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (_) {}
  }, [client, slot]);

  if (!client || !slot) return null;

  return (
    <div className={`ad-banner overflow-hidden ${className}`} aria-label="Advertisement">
      <ins
        ref={insRef}
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client={client}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
}

// Fallback zone shown only in dev when AdSense not configured
export function AdZone({ className = "" }) {
  const client = process.env.REACT_APP_ADSENSE_CLIENT;
  const slot = process.env.REACT_APP_ADSENSE_SLOT_LEADERBOARD;

  if (client && slot) {
    return <AdBanner slot={slot} className={className} />;
  }

  // In production without config: render nothing
  if (process.env.NODE_ENV === "production") return null;

  return (
    <div
      data-testid="ad-zone"
      className={`h-14 rounded-xl bg-slate-50 border border-dashed border-slate-200 flex items-center justify-center text-xs text-slate-300 ${className}`}
      aria-hidden="true"
    >
      Ad Zone — set REACT_APP_ADSENSE_CLIENT + REACT_APP_ADSENSE_SLOT_LEADERBOARD
    </div>
  );
}
